<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">固定特集一覧</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <wj-flex-grid #dtg_ImageInstructList1 [itemsSource]="kymw4501Model.fixedSpecialFeatureList"
          id="dtg_FixedSpecialFeatureList" [headersVisibility]="'Column'"
          [selectionMode]="'Row'" [isReadOnly]="true" [allowSorting]="false" [allowDragging]="'None'"
          [tabindex]="0">
          <wj-flex-grid-filter #fltr_mediumNameList></wj-flex-grid-filter>
          <wj-flex-grid-column [minWidth]="5" [width]="80" [header]="'媒体コード'"
            [binding]="'mediumType'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="460" [header]="'媒体'"
            [binding]="'mediumName'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="80" [header]="'連番'"
            [binding]="'sequenceCode'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="468" [header]="'特集名'"
            [binding]="'featureName'"></wj-flex-grid-column>
        </wj-flex-grid>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>